import React, { Fragment } from 'react';
import { func, object, number } from 'prop-types';
import MapIcon from "./MapIcon";


function Search({ seeAllHotels, showMapView, hotelsLen, countriesLen, theme }) {

  return (
    <Fragment>
      <div className="grid-x align-center find-a-hotel-center-line">
        <div className="cell small-11">
          <hr />
        </div>
        <div className="cell small-11 center-line-text">
          <p>More ways to search</p>
        </div>
      </div>
      <div className="grid-x align-center find-a-hotel-buttons">
        <div className="cell small-11 large-5 buttons-left">
          <div className="cell small-9">
            <p className="text-secondary">
              See our Historic Hotels, all at once
            </p>
            <p className="show-for-large text-primary">
              <strong>Historic Hotels Worldwide® </strong>  is a prestigious collection of more than {hotelsLen} Historic Hotels including former castles, chateaus, palaces, academies, haciendas, villas, monasteries, and other historic lodging.
            </p>
          </div>
          <button
            onClick={seeAllHotels}
            className="cell small-9 button button-main button-content see-all-trigger"
          >
            List of Hotels
          </button>
          <div className="cell small-9">
            <hr className="hide-for-large" />
          </div>
        </div>
        <div className="cell large-2" />
        <div className="cell small-11 large-3 buttons-right">
          <div className="cell small-9">
            <p className="text-secondary">
                {theme && <MapIcon alt={theme.alt} src={theme.src} />}
                Map of Historic Places to Stay
            </p>
            <p className="show-for-large text-primary">
              Historic Hotels Worldwide represents the finest global collection of Historic Hotels in more than {countriesLen} countries.
            </p>
          </div>
          <div className="cell small-9">
            <button
              onClick={showMapView}
              className="button button-main button-content show-map-trigger"
            >
              Discover
            </button>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

Search.propTypes = {
  countriesLen: number.isRequired,
  hotelsLen: number.isRequired,
  seeAllHotels: func.isRequired,
  showMapView: func.isRequired,
    theme: object.isRequired
};

export default Search;
